<script setup lang="ts">
import { PropType } from 'vue';
import baseCollapse from './base/base-collapse.vue';
import { DemoEvent } from '../types';

defineProps({
  events: {
    type: Array as PropType<DemoEvent[]>,
    default: () => [],
  },
})
</script>


<template>
  <div class="rounded-lg bg-gray-200 p-4 overflow-y-auto">
    <p class="text-lg font-bold mb-4">
      Events:
    </p>

    <div class="grid grid-cols-1 gap-y-2">
      <template v-for="event in events" :key="event.type">
        <div
          class="w-full rounded-lg p-2"
          :class="{
            'bg-green-400': event.type === 'success',
            'bg-blue-400': event.type === 'info',
            'bg-red-400': event.type === 'error',
          }"
        >
          <p>
            {{ event.message }}
          </p>

          <base-collapse title="Details">
            <div class="overflow-x-auto pb-4">
              {{ JSON.parse(event.details) }}
            </div>
          </base-collapse>
        </div>
      </template>
    </div>
  </div>
</template>

